import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api } from '../api/client';
import { toast } from 'sonner';
import { ArrowLeft, Rocket, Loader2, Globe, Coins, Zap } from 'lucide-react';

export default function CreateProject() {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleCreate(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    try {
      const data = await api.createProject(name.trim());
      toast.success('Project ready');
      navigate(`/project/${data.project.id}`);
    } catch (e: any) {
      toast.error(e.message);
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-[calc(100vh-48px)] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-accent/10 border border-accent/20 flex items-center justify-center mx-auto mb-4">
            <Rocket size={24} className="text-accent" />
          </div>
          <h1 className="text-xl font-bold mb-1">Create New Project</h1>
          <p className="text-text-muted text-sm">Give your project a name to get started</p>
        </div>

        <form onSubmit={handleCreate} className="card space-y-5">
          <div>
            <label className="block text-sm font-medium mb-2">Project Name</label>
            <input
              value={name}
              onChange={e => setName(e.target.value)}
              className="input text-base"
              placeholder="my-awesome-site"
              autoFocus
              required
            />
            <p className="text-[11px] text-text-muted mt-2 flex items-center gap-1">
              <Globe size={11} />
              {name
                ? `${name.toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') || 'your-site'}.meganhost.dpdns.org`
                : 'your-site.meganhost.dpdns.org'}
            </p>
          </div>

          <div className="flex items-center gap-2 text-xs text-text-muted bg-elevated rounded-lg p-3 border border-border">
            <Coins size={13} className="text-warning shrink-0" />
            <span>This will cost <strong className="text-text-primary">50 MGC</strong> from your balance</span>
          </div>

          <button type="submit" disabled={loading || !name.trim()} className="btn-primary w-full flex items-center justify-center gap-2 py-3 text-base">
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Zap size={18} />}
            Create Project
          </button>
        </form>

        <Link to="/dashboard" className="flex items-center gap-1.5 justify-center mt-4 text-text-muted text-sm hover:text-text-primary transition-colors">
          <ArrowLeft size={14} /> Back to dashboard
        </Link>
      </div>
    </div>
  );
}
